import Vue from "vue";
const state = {
  form: {
    firstName: "",
    lastName: "",
    email: "",
    dealer: "",
    phone: "",
    choises: {},
    orderId: null
  },
  defaults: {},
  formLoaded: false,
  hasForm: false,
  formChanged: false
};

const getters = {
  getForm: state => state.form,
  getFirstName: state => state.form.firstName,
  getLastName: state => state.form.lastName,
  formLoaded: state => state.formLoaded,
  formChanged: state => state.formChanged,
  getDefaults: state => state.defaults,
  hasForm: state => state.hasForm,
  withOrder: state => {
    if (state.form.orderId === (null || 0)) {
      return false;
    } else {
      return true;
    }
  }
};

const actions = {
  /**
   * @description Hydrate choises object
   *
   * @param {Object} { commit }
   * @param {Array} elements
   */
  hydrateChoises({ commit }, elements) {
    commit("hydrateChoises", elements);
  },
  /**
   * @description Set form loaded
   *
   * @param {Object} { commit }
   */
  formLoaded({ commit }) {
    commit("setFormLoaded");
  },
  /**
   * @description Set prefilled choises
   *
   * @param {*} { commit }
   * @param {*} payload
   */
  setChoises({ commit }, payload) {
    commit("setChoises", payload);
  }
};

const mutations = {
  /**
   * @description Set customer first name
   *
   * @param {Object} state
   * @param {String} firstName
   */
  setFirstName(state, firstName) {
    state.form.firstName = firstName;
  },
  /**
   * @description Set customer last name
   *
   * @param {Object} state
   * @param {String} lastName
   */
  setLastName(state, lastName) {
    state.form.lastName = lastName;
  },
  /**
   * @description Set customer email
   *
   * @param {Object} state
   * @param {String} email
   */
  setEmail(state, email) {
    state.form.email = email;
  },
  /**
   * @description Set customer phone
   *
   * @param {Object} state
   * @param {String} phone
   */
  setPhone(state, phone) {
    state.form.phone = phone;
  },
  /**
   * @description Set customer dealer
   *
   * @param {Object} state
   * @param {Object} dealer
   */
  setDealer(state, dealer) {
    state.form.dealer = dealer;
  },
  /**
   * @description Set customer order id
   *
   * @param {Object} state
   * @param {Number} id
   */
  setOrderId(state, id) {
    state.form.orderId = parseInt(id);
  },
  /**
   * @description Update customer choises
   *
   * @param {Object} state
   * @param {Object} choises
   */
  updateChoises(state, choises) {
    state.form.choises = choises;
    state.formChanged = true;
  },
  /**
   * @description Hydrate choises object
   *
   * @param {Object} state
   * @param {Array} elements
   */
  hydrateChoises(state, elements) {
    window._.each(elements, (e, k) => {
      window._.each(e, element => {
        let data = JSON.parse(element.data);
        if (data.type === "ElementItemRadio") {
          if (
            !("category_" + k + "-radio_" + element.id in state.form.choises)
          ) {
            Vue.set(
              state.form.choises,
              "category_" + k + "-radio_" + element.id,
              data.choises.default
            );
            Vue.set(
              state.defaults,
              "category_" + k + "-radio_" + element.id,
              data.choises.default
            );
          }
        } else if (data.type === "ElementItemCheckbox") {
          if (
            !("category_" + k + "-checkbox" + element.id in state.form.choises)
          ) {
            Vue.set(
              state.form.choises,
              "category_" + k + "-checkbox_" + element.id,
              data.choises.defaults
            );
            Vue.set(
              state.defaults,
              "category_" + k + "-checkbox_" + element.id,
              data.choises.defaults
            );
          }
        } else if (data.type === "ElementItemSelect") {
          if (
            !("category_" + k + "-select_" + element.id in state.form.choises)
          ) {
            let selected = window._.find(data.choises.choises, {
              id: data.choises.default
            });
            Vue.set(
              state.form.choises,
              "category_" + k + "-select_" + element.id,
              selected
            );
            Vue.set(
              state.defaults,
              "category_" + k + "-select_" + element.id,
              selected
            );
          }
        }
      });
    });
    state.formLoaded = true;
  },
  /**
   * @description Set prefilled choises
   *
   * @param {*} state
   * @param {*} payload
   */
  setChoises(state, payload) {
    state.form.choises = payload.choises;
    state.defaults = payload.defaults;
  },
  /**
   * @description Set form loaded status
   *
   * @param {Object} state
   */
  setFormLoaded(state) {
    state.formLoaded = true;
  },
  /**
   * @description Clear all choises
   *
   * @param {Object} state
   */
  clearChoises(state) {
    state.form.choises = {};
    state.defaults = {};
  },
  /**
   * @description Check if order form has been filled
   *
   * @param {*} state
   * @param {*} payload
   */
  setHasForm(state, payload) {
    state.hasForm = payload;
  },
  /**
   * @description Clear form
   *
   * @param {*} state
   */
  clearForm(state) {
    state.form = {
      firstName: "",
      lastName: "",
      email: "",
      dealer: "",
      choises: {},
      orderId: 0
    };
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
